import {Loading} from "carbon-components-react"
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper'
import TileHeader from '../../components/TileHeader/TileHeader'
import styled from 'styled-components'
import useClientsGrid from "./useClientsGrid"

const Clients = () => {
  const {
    addClientButton,
    clientSearch,
    clientsGrid,
    clientLoading,
    setClientLoading,
  } = useClientsGrid()

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Clients"
          size="lg"
        />
        {
          clientLoading ?
            <Loading/>
            :
            <></>
        }
        <ClientsContent>
          <ActionBar>
            {clientSearch()}
            {addClientButton()}
          </ActionBar>
          <GridDataContainer>
            {clientsGrid()}
          </GridDataContainer>
        </ClientsContent>
      </ContentContainer>
    </Container>
  )
}

export default Clients;

const GridDataContainer = styled.div`
`

const ClientsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
